/**
 * MOOI MOOI - Scroll Reveal Animations
 *
 * Adds reveal animations to elements with .mooi-reveal class
 * Uses IntersectionObserver for performance-friendly scroll detection
 */

(function() {
  'use strict';

  // Initialize scroll reveal animations
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.mooi-reveal');

    if (revealElements.length === 0) return;

    const observerOptions = {
      threshold: 0.15,
      rootMargin: '-40px'
    };

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Stagger animation with delay based on index
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, index * 100);

          // Unobserve after revealing to improve performance
          revealObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all reveal elements
    revealElements.forEach(el => {
      revealObserver.observe(el);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }

  // Re-initialize on Shopify section updates (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollReveal);
  }
})();
